import { Box, Button } from "@mui/material";
import { useState } from "react";
import { useAppSelector } from "../app/hooks";
import * as userSlice from "../features/user/user.slice";
import Loader from "../components/loader";
import useUsers from "../hooks/use-users";
import UserTable from "../features/user/components/user-table";
import UserForm from "../features/user/components/user-form";
import { UserType } from "../shared/enums";

const Users = () => {
    const [showUserForm, setShowUserForm] = useState(false);
    const isLoading = useAppSelector(userSlice.selectIsLoading);

    const [users] = useUsers();

    // const handleSubmit = (data: BusinessUserRequest) => {
    //     loggedInUser && dispatch(userSlice.createUser({ ...data })).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowUserForm(false);
    //         }
    //     });
    // };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {users &&
                <>
                    <Box>
                        <Button variant="contained" sx={{ float: 'inline-end' }} onClick={() => setShowUserForm(true)} style={{ marginBottom: "12px" }}>Add User</Button>
                    </Box>
                    <UserTable users={users} />
                    {showUserForm &&
                        <UserForm userType={UserType.BUSINESS_USER} user={undefined} editable={true} onClose={() => setShowUserForm(false)} />
                    }
                </>
            }
        </div>
    )
}

export default Users;